import PropTypes from 'prop-types';

export default PropTypes.shape({
    failedAttemptCountLogin: PropTypes.number,
    autoUnlockTimeLogin: PropTypes.number,
    failedAttemptCount2FA: PropTypes.number,
    autoUnlockTime2FA: PropTypes.number,
    autoUnlockTotalCount: PropTypes.number,
    googleTwoFactorAuthentication: PropTypes.bool
})